module.exports = __webpack_public_path__ + "static/media/News-03.9d8c9ca5.png";